import { Component, inject } from '@angular/core';
import { TopProgressBarService } from '../../services/top-progress-bar.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'top-bar-progress-bar',
  templateUrl: './top-bar-progress-bar.component.html',
  styleUrls: ['./top-bar-progress-bar.component.scss'],
  imports: [CommonModule, MatProgressBarModule],
  standalone: true
})
export class TopBarProgressBarComponent {
  service: TopProgressBarService = inject(TopProgressBarService);
}
